export * from './NgForage/NgForage.module';
export * from './NgForage/cache/NgForageCache.service';
export * from './NgForage/config/NgForageConfig.service';
export * from './NgForage/main/NgForage.service';



//////////////////
// WEBPACK FOOTER
// ./src/index.ts
// module id = 9
// module chunks = 0 1